import gql from 'graphql-tag';

const GET_COMERCIAL_POLICY_REFERENCE = gql`
    query getComercialPolicyReference($page: Int, $allData: Boolean) {
        getComercialPolicyReference(page: $page, allData: $allData) {
            internalCode
            totalRecords
            totalPage
            payload {
                id
                comercial_policy
                title
                store_kind
                comercial_policy_reference
            }
        }
    }
`;

export default GET_COMERCIAL_POLICY_REFERENCE;
